module.exports = __webpack_public_path__ + "static/img/logo-dark.515fdf76.png";